<template>
    <div>
        <!-- 日历年月 -->
        <div class='calendar_title flex_nowrap'>
            <div class='icon inline-block' @click='lastMonth'>
                <span class="iconfont iconzuo1" style="font-size:32px"></span>
            </div>
            <div class="inline-block" style="margin: 0 20px;">{{year}}年{{month}}月</div>
            <div class='icon inline-block' @click='nextMonth'>
                <span class="iconfont iconyou-yuan"></span>
            </div>
        </div>

        <!-- 日历主体 -->
        <div class='calendar'>
            <div class='header'>
                <div v-for='(item,index) in date' :key='index' :class='(index == todayIndex) && isTodayWeek ? "weekMark" : ""'>{{item}}
                    <div></div>
                </div>
            </div>

            <div class='date-box'>
                <div v-for='(item,index) in dateArr' :key='index'>
                    <div v-if="item.dateNum" :class="list && list[year+'-'+month+'-'+item.dateNum].status== 1?'stay-class':list && list[year+'-'+month+'-'+item.dateNum].status== 2?'stay-study':list && list[year+'-'+month+'-'+item.dateNum].status== 3?'in-study':list && list[year+'-'+month+'-'+item.dateNum].status== 4?'tips-ok':''">
                        <div class='date-head' @click='lookHuoDong' :data-year='year' :data-month='month' :data-day='item.dateNum'>
                            <div class="date-txt">{{item.dateNum}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "date",
        props: {
            curr_year:Number,
            curr_month:Number,
            list: Object
        },
        data(){
            return {
                year: 0,
                month: 0,
                date: ['日', '一', '二', '三', '四', '五', '六'],
                dateArr: [],
                isToday: 0,
                isTodayWeek: false,
                todayIndex: 0
            }
        },
        mounted() {
            var _self=this;

            var year = this.curr_year*1;
            var month = this.curr_month*1;

            this.dateInit(year,month);
            _self.year=year;
            _self.month = (month+1);
        },
        methods:{
            dateInit: function (setYear, setMonth) {
                var _self=this;
                //全部时间的月份都是按0~11基准，显示月份才+1
                let dateArr = [];                       //需要遍历的日历数组数据
                let arrLen = 0;                         //dateArr的数组长度
                let now = setYear ? new Date(setYear, setMonth) : new Date();
                let year = setYear || now.getFullYear();
                let nextYear = 0;
                let month = setMonth || now.getMonth();                 //没有+1方便后面计算当月总天数
                let nextMonth = (month + 1) > 11 ? 1 : (month + 1);
                let startWeek = new Date(year + '/' + (month + 1) + '/' + 1).getDay();                          //目标月1号对应的星期
                let dayNums = new Date(year, nextMonth, 0).getDate();               //获取目标月有多少天
                let obj = {};
                let num = 0;
                if (month + 1 > 11) {
                    nextYear = year + 1;
                    dayNums = new Date(nextYear, nextMonth, 0).getDate();
                }
                arrLen = startWeek + dayNums;
                for (let i = 0; i < arrLen; i++) {
                    if (i >= startWeek) {
                        num = i - startWeek + 1;
                        obj = {
                            isToday: '' + year + (month + 1) + num,
                            dateNum: num,
                            weight: 5
                        }
                    } else {
                        obj = {};
                    }
                    dateArr[i] = obj;
                }
                _self.dateArr=dateArr;
            },
            /**
             * 上月切换
             */
            lastMonth: function () {
                var _self=this;
                //全部时间的月份都是按0~11基准，显示月份才+1
                let year = this.month - 2 < 0 ? this.year - 1 : this.year;
                let month = this.month - 2 < 0 ? 11 : this.month - 2;

                _self.year=year;
                _self.month = (month+1);

                _self.dateInit(year, month);

                this.$emit('lastMonth', {year:year,month:(month + 1)});
            },
            /**
             * 下月切换
             */
            nextMonth: function () {
                var _self=this;
                //全部时间的月份都是按0~11基准，显示月份才+1
                let year = this.month > 11 ? this.year + 1 : this.year;
                let month = this.month > 11 ? 0 : this.month;

                _self.year=year;
                _self.month = (month+1);

                _self.dateInit(year, month);

                this.$emit('nextMonth', {year:year,month:(month + 1)});
            },
            lookHuoDong:function (e) {
                var dataset=e.currentTarget.dataset;

                this.$emit('datetap', dataset);
            }
        }
    }
</script>

<style scoped>
    div{
        color: #3a3a3a;
    }
    .calendar_title{
        text-align: center;
    }
    .calendar_title .icon .iconfont{font-size: 30px;vertical-align: middle;color: #3a3a3a}
    .inline-block{display: inline-block}
    /* 日历 */
    .calendar{width: 100%;margin-top: 10px;background: #fff;border-bottom-right-radius: 10px;border-bottom-left-radius: 10px;padding: 0 0 10px;font-family: FZZhunYuan-M02S;}
    .header{font-size: 0;width: 95%;margin: 0 auto;}
    .header>div{display: inline-block;width: 14.285%;color: #666;font-size: 15px;text-align: center;border-bottom: 1px solid #D0D0D0;padding: 10px 0;}
    .weekMark{position: relative;width: 95%;margin: 0 auto;}
    .weekMark div{position: absolute;bottom: 0;left: 0;width: 100%;border-bottom: 2px solid #69f;}
    .date-box{font-size: 0;padding: 5px 0;width: 95%;margin: 0 auto;}
    .date-box>div{position: relative;display: inline-block;width: 14.285%;color: #666;text-align: center;vertical-align: middle;margin-bottom: 5px;}
    .date-head{height: 30px;line-height: 30px;font-size: 12pt;}
    .stay-class .date-head,.stay-study .date-head,.in-study .date-head,.tips-ok .date-head{width: 30px;border-radius: 50%;text-align: center;color: #fff;margin: 0 auto;}
    .stay-class .date-head{
        background-color: #d92027;
    }
    .stay-study .date-head{
        background-color: #ff9234;
    }
    .in-study .date-head{
        background-color: #ffcd3c;
    }
    .tips-ok .date-head{
        background-color: #35d0ba;
    }
    .stay-class .date-head .date-txt,.stay-study .date-head .date-txt,.in-study .date-head .date-txt,.tips-ok .date-head .date-txt{color: #fff}
</style>
